<template>
  <div class="previous">
    <el-badge  style="height: 80px;margin-top: 55px" value="hot" >
      <div> <p style="font-size: 34px;margin: 0;">历史会议</p> <p style="font-size: 24px;margin: 0">Past meetings</p></div>
    </el-badge>
    <el-row style="margin-top: 65px" type="flex" justify="center">
      <el-col style="width: 200px">
        <div class="one">
          <div class="item">
            <div class="black"></div>
          </div>
        </div>
      </el-col>
      <el-col style="width: 500px;margin-right: 35px" class="open">
        <el-row v-if="dataForm[0]" style="margin-top: 80px;cursor: pointer">
          <div @click="toSignUp(dataForm[0].confId)">
            <el-col :span="6" style="height: 120px;">
              <div style="width: 180px;height: 120px;background: black;margin-left: 25px;">
                <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[0].poster"  style="height: 100%;width: 100%;">
              </div>
            </el-col>
            <el-col :offset="4"  :span="12" style="height: 60px;">
              <h6>{{dataForm[0].confName}}</h6>
            </el-col>
            <el-col style="height: 60px;width: 150px;margin-left: 100px;overflow: hidden;text-align: left!important;">
              <i class="el-icon-location-information" style="font-size: 12px;line-height: 60px;">
                <span style="height: 30px;line-height: 30px;width: 100%;">{{dataForm[0].venueAddress}}</span>
              </i>
            </el-col>
            <el-col  :span="5" style="height: 60px">
              <i class="el-icon-time" style="font-size: 12px;line-height: 60px;">{{dataForm[0].startTime}}</i>
            </el-col>
          </div>
        </el-row>
        <el-row v-if="dataForm[1]" style="margin-top: 80px;cursor: pointer">
          <div @click="toSignUp(dataForm[1].confId)">
            <el-col :span="6" style="height: 120px;">
              <div style="width: 180px;height: 120px;background: black;margin-left: 25px;">
                <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[1].poster"  style="height: 100%;width: 100%;">
              </div>
            </el-col>
            <el-col :offset="4"  :span="12" style="height: 60px;">
              <h6>{{dataForm[1].confName}}</h6>
            </el-col>
            <el-col style="height: 60px;width: 150px;margin-left: 100px;overflow: hidden;text-align: left!important;">
              <i class="el-icon-location-information" style="font-size: 12px;line-height: 60px;">
                <span style="height: 30px;line-height: 30px;width: 100%;">{{dataForm[1].venueAddress}}</span>
              </i>
            </el-col>
            <el-col  :span="5" style="height: 60px">
              <i class="el-icon-time" style="font-size: 12px;line-height: 60px;">{{dataForm[1].startTime}}</i>
            </el-col>
          </div>
        </el-row>
      </el-col>
      <el-col style="width: 500px;margin-left: 35px" class="open">
        <el-row v-if="dataForm[2]" style="margin-top: 80px;cursor: pointer">
          <div @click="toSignUp(dataForm[2].confId)">
            <el-col :span="6" style="height: 120px;">
              <div style="width: 180px;height: 120px;background: black;margin-left: 25px;">
                <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[2].poster"  style="height: 100%;width: 100%;">
              </div>
            </el-col>
            <el-col :offset="4"  :span="12" style="height: 60px;">
              <h6>{{dataForm[2].confName}}</h6>
            </el-col>
            <el-col style="height: 60px;width: 150px;margin-left: 100px;overflow: hidden;text-align: left!important;">
              <i class="el-icon-location-information" style="font-size: 12px;line-height: 60px;">
                <span style="height: 30px;line-height: 30px;width: 100%;">{{dataForm[2].venueAddress}}</span>
              </i>
            </el-col>
            <el-col  :span="5" style="height: 60px">
              <i class="el-icon-time" style="font-size: 12px;line-height: 60px;">{{dataForm[2].startTime}}</i>
            </el-col>
          </div>
        </el-row>
        <el-row v-if="dataForm[3]" style="margin-top: 80px;cursor: pointer">
          <div @click="toSignUp(dataForm[3].confId)">
            <el-col :span="6" style="height: 120px;">
              <div style="width: 180px;height: 120px;background: black;margin-left: 25px;">
                <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[3].poster"  style="height: 100%;width: 100%;">
              </div>
            </el-col>
            <el-col :offset="4"  :span="12" style="height: 60px;">
              <h6>{{dataForm[3].confName}}</h6>
            </el-col>
            <el-col style="height: 60px;width: 150px;margin-left: 100px;overflow: hidden;text-align: left!important;">
              <i class="el-icon-location-information" style="font-size: 12px;line-height: 60px;">
                <span style="height: 30px;line-height: 30px;width: 100%;">{{dataForm[3].venueAddress}}</span>
              </i>
            </el-col>
            <el-col  :span="5" style="height: 60px">
              <i class="el-icon-time" style="font-size: 12px;line-height: 60px;">{{dataForm[0].startTime}}</i>
            </el-col>
          </div>
        </el-row>
      </el-col>
      <el-col style="width: 200px">
        <div class="one">
          <div class="item">
            <div class="black"></div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row  type="flex" justify="center" style="margin-top: 45px;">
      <el-button style="font-size: 16px;height: 40px;padding-top: 10px;padding-left: 25px" type="info" round @click="toMore">
        For more information
        <i class="el-icon-arrow-right el-icon--right"></i>
      </el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "previous2",
  props: {},
  data(){
    return{
      dataForm:[],
    }
  },
  methods: {
    async toSignUp(id){
      let routeData = this.$router.resolve({ path: '/signup',query:{id:id}
      });
      window.open(routeData.href, '_blank');
    },
    toMore(){
      let routeData = this.$router.resolve({ path: '/more'});
      window.open(routeData.href, '_blank');
    },
    async getList(){
      const { data: res } = await this.$http.get('api/conference/confDetailed/user/pastListLimit4/')
      // console.log(res);
      this.dataForm =res.data
    },
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped lang="less">
.previous{
  background-color: white;
  color: #333;
  text-align: center;
  height: 900px;
}
.one .item{
  width: 200px;
  height: 500px;
  background-image: url("../assets/previous_1.png");
}
.black{
  cursor: pointer;
  width: 200px;
  height: 500px;
  background-color: rgba(0,0,0,.5);
  color: #fff;
  opacity: 0.8;
  border-right: 1px solid white;
}
.open{
  width: 500px;
  height: 500px;
  background-color: #f2f2f2;
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
h6 {
  line-height: 20px;
  font-size: 16px;
  width: 250px;
  height: 60px;
  word-break:break-word;
  margin: 0;
  overflow: hidden;text-overflow:ellipsis;
  text-align: left;
  margin-left: 15px;
  color: #333333;
  font-family: inherit;
  font-weight: 500;
}
</style>
